var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarEventDuclo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333008,
    width: 36,
    height: 36,
    rx: 8,
    fill: "#0052cc"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9997 20.6666V13.9999C18.9997 13.6317 18.7012 13.3333 18.333 13.3333H12.9997C12.6315 13.3333 12.333 13.6317 12.333 13.9999V20.6666C12.333 21.0348 12.6315 21.3333 12.9997 21.3333H13.6663M18.9997 20.6666C18.9997 21.0348 18.7012 21.3333 18.333 21.3333H16.333M18.9997 20.6666L18.9997 15.3333C18.9997 14.9651 19.2982 14.6666 19.6663 14.6666H21.3902C21.567 14.6666 21.7366 14.7368 21.8616 14.8618L24.1377 17.138C24.2628 17.263 24.333 17.4326 24.333 17.6094V20.6666C24.333 21.0348 24.0345 21.3333 23.6663 21.3333H22.9997M18.9997 20.6666C18.9997 21.0348 19.2982 21.3333 19.6663 21.3333H20.333M13.6663 21.3333C13.6663 22.0696 14.2633 22.6666 14.9997 22.6666C15.7361 22.6666 16.333 22.0696 16.333 21.3333M13.6663 21.3333C13.6663 20.5969 14.2633 19.9999 14.9997 19.9999C15.7361 19.9999 16.333 20.5969 16.333 21.3333M20.333 21.3333C20.333 22.0696 20.93 22.6666 21.6663 22.6666C22.4027 22.6666 22.9997 22.0696 22.9997 21.3333M20.333 21.3333C20.333 20.5969 20.93 19.9999 21.6663 19.9999C22.4027 19.9999 22.9997 20.5969 22.9997 21.3333",
    stroke: "#641616",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarEventDuclo);
export default __webpack_public_path__ + "static/media/CarEventDuclo.5eddfdfb123d501e7e09bb75464cba64.svg";
export { ForwardRef as ReactComponent };